import { createStore, applyMiddleware } from 'redux';
import rootReducer from './reducers';
import createLogger from 'redux-logger'
import thunk from 'redux-thunk'

export default function configureStore(initialState){
    const logger = createLogger();
    const store = createStore(rootReducer, initialState, applyMiddleware(thunk, logger));

    if (module.hot) {
        module.hot.accept('./reducers', () => {
            const nextRootReducer = require('./reducers').default;
            console.log('inject next root reducer', nextRootReducer);
            store.replaceReducer(nextRootReducer)
        })
    }

    return store;
}


// WEBPACK FOOTER //
// ./src/store/createStore.js